export const FOOTER_HEIGHT = 44;
export const ANIMATION_DURATION_TIME = 400;
export const CARD_ANIMATION_TIME = 300;
